import { boot } from 'quasar/wrappers'
import { AuthSocket } from '../services/socket/AuthSocket'
import { LiveSocket } from '../services/socket/LiveSocket'

export default boot(({ app, store, router }) => {
  const authSocket = new AuthSocket(store)
  const liveSocket = new LiveSocket(store, router, app.config.globalProperties.$emitter)

  app.config.globalProperties.$SOCKET = {
    auth: authSocket,
    live: liveSocket,
  }
})
